// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"59216d17","205":"65de784d","221":"3e8fc934","239":"90dea0c5","455":"3c8f584f","551":"3ccf42b0","833":"29d7692f","977":"72c3a0f4","988":"e578391b"}[chunkId] + ".chunk.js";
};